export default {
  "error": {
    "required": "Le champ est requis",
    "forbiddenSymbols": "Certains symboles sont interdits",
    "numeric": "Le champ doit être numérique",
    "minMax": "Le champ doit etre entre {0} et {1} caractères",
    "email": "Email invalide",
    "amount": "Montant invalide",
    "selectedPlayer": "Veuillez sélectionner un joueur",
    "passwordsMismatch": "incompatibilité des mots de passe",
    "signInUp": {
      "1": "Le nom d'utilisateur n'existe pas",
      "2": "Le mot de passe est incorrect",
      "4": "Le mot de passe doit contenir à la fois des lettres et des chiffres de 6 à 16 caractères",
      "5": "Veuillez fournir un e-mail valide",
      "6": "Cet e-mail n'est connecté à aucun compte.",
      "7": "Le champ est vide",
      "8": "Le nom d'utilisateur doit contenir au moins 3 symboles",
      "9": "Symboles max 16",
      "10": "Sans espaces",
      "422": "Ce nom d'utilisateur est déjà pris"
    }
  },
  "messages": {
    "joinClubSucces": "Demande de jointure envoyée avec succès.",
    "createClubSuccess": "Nouveau club créé avec succès.",
    "balanceTransferSuccess": "Le transfert est réussi.",
    "waitingForData": "En attente d'une donnée",
    "deleteSuccess": "Le compte a été supprimé avec succès",
    "changePasswordSuccess": "Le mot de passe a été modifié avec succès",
    "forgotPasswordSuccess": "Votre demande est envoyée avec succès",
    "counterMessage1": "Envoyer {0} à {1}",
    "clubWrongBalanceMessage1": "Vous n'avez que {0} mais vous voulez transférer le total {1} ​​veuillez ajouter clubBalance et réessayer",
    "claimBackWrongMessage1": "Vous souhaitez récupérer la réclamation {0} mais {1} n'en avez que {2}",
    "counterMessage2": "Retirer {0} de {1}",
    "emailDeleteInfo": "Les e-mails seront supprimés après 30 jours",
    "subFotterText": "Termes et conditions",
    "changeRoleConfirmation": "Voulez-vous vraiment modifier les autorisations utilisateur",
    "bonusSuccess": "Félicitations, vous avez reçu {0} bonus!",
    "clubPlayerRemove": "Vous êtes sûr de quitter le club?",
    "unableExport": "Les rapports d'exportation ne sont pas disponibles pour votre compte"
  },
  "signInUp": {
    "username": "Nom d'utilisateur",
    "password": "Mot de passe"
  },
  "maxClaimBack": "Réclamation maximale par joueur: {0}",
  "cancel": "Annuler",
  "confirm": "Confirmer ",
  "from": "De",
  "to": "à",
  "days": "Jours",
  "trade": "Commerce",
  "sendVip": "Envoyer VIP\r\n",
  "tradeRecord": "Record commercial",
  "all": "tout",
  "downline": "",
  "allTime": "Tout le temps",
  "last7Days": "Les derniers 7 jours",
  "dialogTitleEmail": "Email",
  "vipStatusOff": "Inactif",
  "vipValidDate": "(Valide pour 30 jours)",
  "logInNow": "S'identifier maintenant",
  "haveAnAccount": "Avez-vous un compte?",
  "dialogTitlePopUp": "Fenêtre de messagerie",
  "member": "Membre",
  "manager": "Directeur",
  "agent": "Agent",
  "player": "Membre",
  "userId": "Identifiant de l'utilisateur",
  "details": "Détails ",
  "uplineAgent": "",
  "buyProduct": "Acheter un produit",
  "leagueHeader": "Ligue",
  "gamesCareer": "Carrière de jeux",
  "total": "Total",
  "tips": "Conseils",
  "doYouConfirm": "Confirmez-vous",
  "game": "Jeu",
  "games": "Jeux",
  "sport": "Sport",
  "sports": "Sports",
  "poker": "Poker\r\n",
  "casino": "casino",
  "liveCasino": "Casino en direct ",
  "cashout": "Retrait",
  "multiBet": "Multi-paris",
  "systemBet": "Pari système",
  "margin": "Marge",
  "theme": "Thème",
  "playerWinnings": "Gains des joueurs",
  "winnings": "Gains",
  "hand": "Mains",
  "join": "Joindre",
  "joinClub": "Rejoindre le club",
  "joinUnion": "Rejoindre l'union",
  "createAClub": "Créer un club",
  "codeForClubCreation": "Entrez le code pour la création du club",
  "sentTo": "Envoyer à",
  "exchange": {
    "chips": "piéces",
    "sapphires": "Saphirs",
    "currentBalance": "Solde actuel",
    "currentExchange": "Échange actuel",
    "sapphireExchange": "",
    "minExchangeAmount": "Montant minimum d'échange",
    "convert": "Convertir"
  },
  "createUnion": "Créer une union",
  "grandCreditHistory": "Grand historique de crédit",
  "soundEffects": "effets sonores",
  "memberEditing": "ÉDITION DES MEMBRES",
  "timeSliderName": "Le temps d'action",
  "blindSliderName": "aveugle",
  "gameLengthSliderName": "durée du jeu",
  "buyInSliderName": "acheter dans",
  "minBuyInText": "Achat Min",
  "maxBuyInText": "Achat max",
  "newTableDialogTitle": "Nouvelle table",
  "blinds": "stores",
  "clubLeague": "matchs de championnat",
  "clubCapitalize": "club",
  "clubId": "identifiant du club",
  "unionId": "identifiant d'union",
  "agentId": "identifiant de l'agent",
  "id": "identifiant",
  "lv": "ID",
  "fee": "frais",
  "pokerGames": "jeux de poker",
  "spins": "tours de casino",
  "bettings": "paris",
  "wl": "gains",
  "nickname": "surnom",
  "lastLogin": "Dernière connexion",
  "create": "créer",
  "createClub": "créer un club",
  "selectAvatar": "sélectionnez Avatar",
  "selectCountry": "choisissez le pays",
  "clubCreation": "création de club",
  "clubDescriptionAndRules": "Description et règles du club",
  "hands": "Mains",
  "validFor": "valable",
  "levelUpdate": "mise à jour de niveau",
  "wantToBuy": "Veux-tu acheter",
  "ourSubItem": "Notre sous-article",
  "createNewClub": "créer un nouveau club ",
  "joinNewClub": "Rejoignez un club",
  "clubName": "nom du club",
  "clubNotice": "avis du club",
  "content": "contenu",
  "clubDisband": "Êtes-vous certain de vouloir dissoudre le club?",
  "deleteClubMember": "Voulez-vous vraiment supprimer ce membre?",
  "changeRole": "Confirmer pour changer le rôle d'utilisateur?",
  "changeRoleFromAgent": "Les données de la lignée descendante actuelle seront supprimées si vous modifiez les droits de cet agent.Êtes-vous sûr?",
  "freeToRename": "Gratuit de renommer pour la première fois",
  "welcomeMessagePart1": "Bienvenue à",
  "welcomeMessagePart2": "Pour toute demande, veuillez contacter",
  "loadingTablesList": "Chargement de la liste des tableaux ..",
  "notificationIsValid": "Chaque notification est valable 24 heures",
  "jackpot": "Cagnotte",
  "commision": "commission",
  "selectDownline": "",
  "recruitedByTheAgent": "Veuillez marquer les joueurs nommés par l'agent",
  "levelHasExpired": "Votre niveau de club a expiré, veuillez renouveler.",
  "grantSendOutLimit": "Accorder la limite d'envoi à l'agent",
  "currentDownline": "Descendance actuelle",
  "agentManagement": "gestion des agents",
  "wantToChangeDownline": "Voulez-vous vraiment changer",
  "wantToRemove": "Voulez-vous vraiment supprimer",
  "notifications": "notifications",
  "quitTheClub": "Quittez le club",
  "oddDefaultFormat": "Format par défaut des cotes",
  "clubChipBalance": "Solde des jetons du club",
  "exchangeSapphires": "100 saphirs = 40",
  "multipleOf100": "Veuillez saisir un multiple entier de 100",
  "clubEditing": "",
  "startAnewTable": "Commencer un nouveau programme",
  "change": "changement",
  "coins": "pièces de monnaie",
  "items": "éléments",
  "sapphires": "saphirs",
  "clubHeadline1": "Il est indéniable que le succès d'une publicité réside principalement dans le titre. Le titre devrait attirer les",
  "showMore": "Montre plus",
  "clubHeadline2": "",
  "showLess": "Montrer moins",
  "disbandClub": "Afin de confirmer la dissolution du club, veuillez saisir votre identifiant de club dans le champ de saisie.",
  "disbandUnion": "Afin de confirmer la dissolution de l'Union, veuillez saisir votre identifiant Union dans le champ de saisie.",
  "quitTheUnion": "Afin de confirmer la sortie du syndicat, veuillez saisir votre identifiant syndical dans le champ de saisie.",
  "overall": "Global",
  "yesterday": "hier",
  "past7Days": "les 7 derniers jours ",
  "select": "sélectionner",
  "overallWinnings": "Gains globaux",
  "pokerWinnings": "Gains de poker",
  "casinoWinnings": "Gains de casino",
  "bettingWinnings": "Paris sur les gains",
  "pokerFeeAmount": "Montant des frais de poker",
  "pokerFee": "Frais de poker",
  "gamesPoker": "Jeux de poker",
  "spinsCasino": "Tours de casino",
  "deleteMember": "Supprimer un membre",
  "dateCreated": "Temps joint",
  "chipBalance": "Équilibre de puce",
  "sent": "Expédié",
  "totalChips": "Total de jetons de joueurs Exclut les jetons en jeu",
  "yourChipsAmount": "Le montant de vos jetons",
  "claimedBack": "Revendiqué",
  "tradeCommission": "{0}% de commission prélevée pour ce commerce",
  "areComingSoon": "arrivent bientôt",
  "nlh": "",
  "plo": "",
  "ofc": "",
  "ringGame": "Ring Game",
  "sng": "",
  "mtt": "",
  "regularMode": "Mode régulier",
  "progressiveMode": "Progressive",
  "ultimateMode": "Ultime",
  "sixPlus": "6+",
  "fourCard": "4 cartes",
  "fiveCard": "5 cartes ",
  "concurrent": "concurrent",
  "sequential": "séquentiel",
  "operationSequence": "Séquence d'opération",
  "autoStart": "démarrage automatique",
  "autoExtension": "Extension automatique",
  "times": "Fois",
  "autoOpen": "Ouverture automatique",
  "riskManagement": "Gestion des risques",
  "multiTimeRun": "Exécutez-le plusieurs fois",
  "evChop": "",
  "cap": "Casquette",
  "callTime": "Temps d'appel",
  "autorizedToBuyin": "Autorisé à acheter",
  "byh": "Misez votre main",
  "gpsRestriction": "Restriction GPS",
  "ipRestriction": "Restriction IP",
  "banChatting": "Interdire le chat",
  "tableCost": "Coût de la table",
  "balance": "Equilibre",
  "grantCredit": "Accorder un crédit",
  "selectDownlineText": "Marquez les joueurs que vous souhaitez affecter à cette descendance",
  "creditBalance": "Solde créditeur",
  "grantCreditText": "De là, vous pouvez envoyer et récupérer des jetons de club",
  "unionClubs": "syndicat",
  "unionJoinRequests": "Les demandes de rejoindre ",
  "unionData": "données syndicales",
  "unionEditingContent": {
    "change": "Changement",
    "label": "Nom de l'union",
    "notice": "Libre de renommer pour la première fois",
    "save": "Enregistrer",
    "price": "Changer le nom du club ",
    "notEnough": {
      "0": "Vous n'avez pas assez de saphirs,",
      "1": "Cliquez ici",
      "2": "acheter des saphirs"
    }
  },
  "information": "information",
  "dataIsRecordedBasedOnUnionHeadData": "Les données sont enregistrées en fonction du fuseau horaire de Union Head:",
  "pokerWinLossFee": "Poker gain / perdu + frais",
  "pokerWinLossFeeOverall": "Global",
  "pokerWinLossFeeLastWeek": "Derniére semaine",
  "pokerWinLossFeeThisWeek": "Cette semaine",
  "suspend": "Suspension",
  "remove": "supprission",
  "exportData": "Exporter des données",
  "betYourHand": {
    "combinations": "Combinaisons",
    "amount": "X1 / X2",
    "max": "Max",
    "nlh": {
      "0": {
        "title": "",
        "description": "",
        "amount": "100",
        "max": "250",
        "combinations": ""
      },
      "1": {
        "title": "",
        "description": "Super Royal Flush",
        "amount": "30",
        "max": "50",
        "combinations": ""
      },
      "2": {
        "title": "",
        "description": "",
        "amount": "10",
        "max": "10",
        "combinations": ""
      },
      "3": {
        "title": "",
        "description": "",
        "amount": "1.5",
        "max": "1.5",
        "combinations": ""
      },
      "4": {
        "title": "",
        "description": "",
        "amount": "200",
        "max": "200",
        "combinations": ""
      },
      "5": {
        "title": "",
        "description": "",
        "amount": "100",
        "max": "100",
        "combinations": ""
      },
      "6": {
        "title": "",
        "description": "",
        "amount": "10",
        "max": "10",
        "combinations": ""
      },
      "7": {
        "title": "",
        "description": "",
        "amount": "10",
        "max": "10",
        "combinations": ""
      },
      "8": {
        "title": "",
        "description": "",
        "amount": "10",
        "max": "10",
        "combinations": ""
      }
    },
    "plo": {
      "0": {
        "title": "",
        "description": "",
        "amount": "100",
        "max": "250",
        "combinations": ""
      },
      "1": {
        "title": "",
        "description": "",
        "amount": "30",
        "max": "50",
        "combinations": ""
      },
      "2": {
        "title": "",
        "description": "",
        "amount": "10",
        "max": "10",
        "combinations": ""
      },
      "3": {
        "title": "",
        "description": "",
        "amount": "1.5",
        "max": "1.5",
        "combinations": ""
      },
      "4": {
        "title": "",
        "description": "",
        "amount": "200",
        "max": "200",
        "combinations": ""
      },
      "5": {
        "title": "",
        "description": "",
        "amount": "100",
        "max": "100",
        "combinations": ""
      },
      "6": {
        "title": "",
        "description": "",
        "amount": "10",
        "max": "10",
        "combinations": ""
      },
      "7": {
        "title": "",
        "description": "",
        "amount": "10",
        "max": "10",
        "combinations": ""
      }
    }
  },
  "exportRecord": "Exporter l'enregistrement",
  "exportDate": "Date d'exportation",
  "pleaseEnterValidEmail": "veuillez saisir un e-mail valide",
  "playerData": "Données du joueur",
  "sapphireStatement": "Déclaration de saphir",
  "tradeRecords": "Dossiers commerciaux",
  "upgradeToJoinText": "Votre club doit être de rang 2 ou supérieur pour adhérer à une Union",
  "upgradeToCreateText": "Votre club doit être de rang 2 ou supérieur pour créer une Union",
  "clubDataHelp": [
    ["Global", "Affiche les données depuis que l'utilisateur a rejoint le club"],
    ["7 derniers jours", "Affiche les données des 7 derniers jours"],
    ["Sélectionner", "Affiche les données des dates sélectionnées."],
    ["Gains globaux", "Affiche les données du nombre de jetons gagnés / perdus par l'utilisateur à travers tous les jeux."],
    ["Gains de poker", "Affiche les données du nombre de jetons gagnés / perdus par les utilisateurs de poker."],
    ["Gains de casino", "Affiche les données du nombre de jetons gagnés / perdus par les utilisateurs des jeux de casino."],
    ["Montant des frais", "Indique le montant des frais de poker remis au club"]
  ],
  "footer": {
    "items": {
      "home": "Accueil",
      "shop": "Boutique",
      "career": "Carrière",
      "profile": "Profil",
      "messages": "messages",
      "settings": "Paramètres",
      "data": "Les données",
      "members": "Membres",
      "counter": "Compteur"
    }
  },
  "agentDetails": {
    "memberAmount": "Montant du membre {0}"
  },
  "language": {
    "en": "Anglais",
    "tur": "turc",
    "id": "indonésien",
    "de": "allemand"
  },
  "dialog": {
    "tutorial": "Didacticiel",
    "createClub": "Créer un club",
    "createAClub": "Créer un club",
    "joinClub": "Rejoignez le club",
    "selectAvatar": "Sélectionnez un avatar",
    "selectCountry": "Choisissez le pays",
    "coins": "Pièces de monnaie",
    "notification": "Notification",
    "sapphires": "Saphirs",
    "exchange": "Échange",
    "editClub": "Édition du club",
    "disbandClub": "Dissoudre le club",
    "disbandUnion": "Dissoudre l'Union",
    "deleteMember": "Confirmation",
    "editMemberInfo": "Modifier les informations sur les membres",
    "changeRole": "Confirmation",
    "mission": "Missions",
    "unionNotice": "Avis du syndicat",
    "joinUnion": "Se syndiquer",
    "createUnion": "Créer une union",
    "createLabel": "Entrez le nom de l'union",
    "joinLabel": "Entrez l'identifiant de l'Union",
    "unionAuthority": "Autorité",
    "selectAuthority": {
      "text": "Sélectionnez l'autorité pour créer des tables de poker",
      "current": "Propriétaires et gestionnaires actuels de club",
      "all": "Tous les propriétaires et gérants de club"
    },
    "unionConfirm": "Confirmer",
    "unionTerms": {
      "one": "1. Seuls les clubs deux étoiles ou plus peuvent créer ou rejoindre une Union.",
      "two": "2. Après avoir créé ou rejoint une fédération, les jetons enregistrés dans votre club seront toujours disponibles dans cette fédération particulière. Cependant, les jetons détenus par les agents et les joueurs seront supprimés",
      "agreement": "J'ai lu les termes et conditions"
    },
    "clubDetails": "Détails du club",
    "upgradeToCreate": "Impossible de créer une union",
    "upgradeToJoin": "Impossible d'adhérer à un syndicat",
    "unionConfirmation": "Détails de l'Union",
    "clubConfirmation": "Détails du club",
    "renewLevel": "Impossible de créer la table",
    "agentDetails": "Détails de l'agent",
    "quitTheUnion": "Quittez l'Union",
    "export": "Exportation",
    "notEnoughFunds": "Pas assez de fonds",
    "memberMenu": "Détails du club",
    "clubInfo": "Informations sur le club",
    "betYourHand": "Chances"
  },
  "settings": {
    "text": "Paramètres",
    "twoStepVerification": "Vérification en deux étapes",
    "changePassword": "Changer le mot de passe",
    "changeEmail": "Changer l'e-mail",
    "languages": "les langues",
    "avatar": "Avatar",
    "details": "Détails",
    "linkEmail": "Liez votre e-mail",
    "language": "Langue",
    "select": "Sélectionner",
    "logOut": "Se déconnecter"
  },
  "clubLevelName": {
    "1": "Club une étoile",
    "2": "Club deux étoiles",
    "3": "Club trois étoiles",
    "4": "Club quatre étoiles",
    "5": "Club cinq étoiles",
    "6": "Club Six étoiles",
    "7": "club sept étoiles",
    "8": "clubs huit étoiles",
    "9": "Club neuf étoiles",
    "10": "Club dix étoiles",
    "11": "Super Star Club"
  },
  "changePassword": {
    "text": "Changer le mot de passe",
    "current": "Mot de passe actuel",
    "new": "nouveau mot de passe",
    "repeat": "Confirmez le mot de passe",
    "confirm": "Confirmer"
  },
  "linkEmail": {
    "text": "Liez votre e-mail",
    "writeYourEmail": "Écrivez votre e-mail ici et nous vous enverrons un code pour vérification",
    "emailAddress": "Adresse électronique",
    "resendCode": "Renvoyer le code de vérification",
    "checkYourMail": "Veuillez vérifier votre code de vérification dans la boîte aux lettres, il peut s'agir de la boîte spam"
  },
  "passwordRecovery": {
    "emailField": "Adresse électronique",
    "title": "Récupération de mot de passe",
    "description": "Écrivez votre adresse e-mail que vous avez utilisée lors de l'inscription.",
    "sendEmail": "Envoyer un e-mail",
    "successDescription": "Nous vous envoyons un nouveau mot de passe temporaire. Vous pouvez l'utiliser pour entrer dans le jeu. Après vous être connecté, vous pouvez changer le mot de passe dans le menu Paramètres du jeu",
    "goBack": "Retourner"
  },
  "tutorial": {
    "text": "Didacticiel",
    "accountSettings": "Paramètres du compte",
    "leagueGames": "jeux de foot",
    "clubs": "Clubs",
    "shop": "Boutique",
    "dailyBonus": "Bonus quotidien",
    "accountLevelsAndXP": "Niveaux de compte et XP",
    "friendInvite": "Inviter un ami"
  },
  "about": {
    "text": "À propos",
    "gameRules": "Regles du jeu",
    "contactInfo": "Informations de contact",
    "termsAndConditions": "Termes et conditions",
    "privacyPolicy": "Politique de confidentialité"
  },
  "leaderboard": {
    "text": "Classement",
    "remaining": "Temps restant",
    "rank": "Rang",
    "name": "Nom",
    "points": "Vos points",
    "reward": "Récompense",
    "daily": "Du quotidien",
    "weekly": "hebdomadaire",
    "monthly": "mensuel"
  },
  "leaderboardInfo": {
    "text": "Informations sur le classement",
    "hints": "Conseils",
    "rewards": "Récompenses"
  },
  "leaderboardHints": {
    "text": "Conseils",
    "rule": "En jouant à des matchs de ligue ou de club, les joueurs gagneront des points et participeront aux classements. À la fin du chronomètre, les joueurs parmi les dix premiers recevront des récompenses.",
    "hintsText": {
      "0": {
        "header": "Astuce 1",
        "text": "Vous pouvez gagner des points de classement en jouant au poker, aux jeux de casino et en faisant des paris dans la ligue et les clubs."
      },
      "1": {
        "header": "Astuce 2",
        "text": "Jouer à des jeux et faire des paris dans les clubs vous donnera plus de points que les matchs de ligue"
      },
      "2": {
        "header": "Astuce 3",
        "text": "Les points sont définis par le montant d'argent que vous gagnez, le gros pari vous donnera une plus grande récompense et aussi beaucoup de points.\r\n"
      },
      "3": {
        "header": "Astuce 4",
        "text": "Vos points seront réinitialisés à la fin du chronomètre. Mais si vous n'avez pas réussi à entrer dans le top 20 des classements quotidiens, vous aurez toujours la possibilité d'augmenter ce point et d'entrer dans le top 20 des classements hebdomadaires ou mensuels."
      }
    }
  },
  "level": {
    "currentXp": " Niveaux actuel",
    "requiredXp": "Niveaux requis",
    "gainXp": "Jouez au poker, au casino ou faites-le pour gagner de niveaux et passer au niveau supérieur",
    "accountLevel": "Niveau du compte",
    "levelRewards": "Récompenses de niveau {0}"
  },
  "shop": {
    "text": "Boutique",
    "coins": {
      "text": "Pièces de monnaie"
    },
    "items": {
      "text": "Articles",
      "silverCard": "Carte d'argent",
      "goldCard": "Carte d'Or",
      "platinumCard": "Carte Platine",
      "avatars": "",
      "emojis": "Emojis"
    },
    "sapphires": {
      "text": "Saphirs"
    },
    "mostPopular": "Le plus populaire",
    "bestValue": "Meilleure valeur"
  },
  "support": {
    "text": "Soutien"
  },
  "time": {
    "s15": "15 secondes ",
    "s20": "20 secondes",
    "s30": "30 secondes"
  },
  "number": {
    "one": "1",
    "onePointFive": "1.5",
    "two": "2",
    "twoPointFive": "2.5",
    "three": "3",
    "fout": "4",
    "five": "5",
    "six": "6"
  },
  "dash": {
    "claimBack": "Réclamer",
    "buyIn": "Acherter a "
  },
  "button": {
    "ok": "D'accord",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "claimBack": "Réclamer",
    "sendOut": "Envoyer",
    "send": "Envoyer",
    "oneMore": "Un de plus",
    "buy": "Acheter",
    "done": "Terminé",
    "submit": "Soumettre",
    "quit": "Quittez le club",
    "sapphire": "Saphir",
    "select": "Sélectionner",
    "save": "sauver",
    "sendVip": "Envoyer VIP",
    "upgrade": "Améliorer",
    "close": "Fermer",
    "create": "Créer",
    "join": "Joindre",
    "apply": "Appliquer",
    "claim": "Prétendre"
  },
  "header": {
    "clubData": "Données du club",
    "clubDetails": "Détails du club",
    "clubChips": "Jetons de club",
    "clubRating": "Évaluation du club",
    "title": "Titre"
  },
  "playerMenu": {
    "playerMenuTitle": "Détails du joueur",
    "trade": "Record commercial",
    "jackpot": "Cagnotte",
    "quit": "Quittez le club"
  },
  "agentMenu": {
    "agentMenuTitle": "Détails de l'agent",
    "grantCredit": "Accorder un crédit"
  },
  "career": {
    "items": {
      "poker": "Mains",
      "sportsbook": "Paris",
      "casino": "Paris"
    },
    "periods": {
      "day": "journée",
      "month": "mois",
      "year": "an"
    },
    "range": {
      "all": "Tout le temps",
      "lastWeek": "Les 7 derniers jours",
      "purchase": "Achetez une carte Gold ou supérieure pour des données plus détaillées"
    },
    "reports": {
      "game": "Jeu",
      "hand": "Main"
    },
    "menu": {
      "filters": "Filtres"
    },
    "menuRow": {
      "all": "Tout",
      "poker": "Poker",
      "casino": "Casino",
      "betting": "Pari"
    }
  },
  "options": {
    "clubChips": "{1} Chips {0}",
    "newMessage": "Notifications",
    "buyLevel": "Classement du club LVL {0}",
    "promotion": "Promotion",
    "disband": "Dissoudre le club",
    "leftDays": "({0} jours restants)",
    "grandCredit": "Historique du grand crédit",
    "quit": "Quittez le club"
  },
  "union": {
    "clubs": "Clubs de l'Union",
    "requests": "Rejoindre les demandes",
    "data": "Données de l'Union",
    "authority": "Autorisation de créer des tables de poker",
    "disband": "Dissoudre l'Union",
    "quit": "Quitter l'union"
  },
  "club": {
    "text": "club",
    "poker": "Poker",
    "betting": "Pari",
    "casino": "Casino",
    "games": {
      "poker": {
        "admin": "Actuellement, les jeux de casino ne sont pas disponibles. Afin de le rendre disponible, veuillez renouveler la note de votre club",
        "member": "Il n'y a actuellement aucune table de poker disponible"
      },
      "casino": {
        "admin": "Actuellement, les jeux de casino ne sont pas disponibles. Afin de le rendre disponible, veuillez renouveler la note de votre club",
        "member": "Les jeux de casino ne sont pas disponibles pour le moment"
      },
      "betting": {
        "admin": "Actuellement, les paris ne sont pas disponibles. Afin de le rendre disponible, veuillez renouveler la note de votre club",
        "member": "Le pari n'est pas disponible pour le moment"
      },
      "renew": "Renouveler"
    }
  },
  "clubItems": {
    "options": "Options du club",
    "notifications": "Notifications",
    "members": "Détails des membres",
    "counter": "Compteur",
    "tradeRecords": "Dossiers commerciaux",
    "memberDetails": "Détails des membres",
    "clubRatings": "Évaluations du club",
    "claimBack": "Réclamer",
    "sendOut": "Envoyer",
    "data": "Données du club",
    "union": "syndicat",
    "unionEditing": "Modification de l'union",
    "agentMenu": "Menu de l'agent"
  },
  "memberDetails": {
    "trackPlayer": "Joueur de piste",
    "roleSelection": "Choisissez un rôle",
    "clubRatings": "Notes de club",
    "editMemberInfo": {
      "alias": "Ajouter des alias",
      "notes": "Ajouter des notes"
    }
  },
  "tradeDirection": {
    "sent": "Envoyé à:",
    "claimedBack": "Revendiqué de:"
  },
  "members": "Membres",
  "newMembers": "Nouveaux membres",
  "betting": "Pari",
  "title": "Titre",
  "chips": "Chips ",
  "currentPassword": "Mot de passe actuel",
  "newPassword": "nouveau mot de passe",
  "repeatPassword": "Répéter le mot de passe",
  "email": "E-mail",
  "login": "S'identifier",
  "version": "Version",
  "loginObj": {
    "text": "Vous n'avez pas de compte?",
    "link": "S'inscrire maintenant!"
  },
  "registerObj": {
    "text": "Vous avez déjà un compte?",
    "link": "se connecter"
  },
  "forgotPassword": "Mot de passe oublié",
  "loginBonus": "Bonus de connexion",
  "insurance": "Assurance",
  "totalPokerFees": "Total des frais de poker\r\n",
  "pokerFees": "Frais de poker",
  "totalWinnings": "Le total des gains",
  "winningsLastWeek": "Gains la semaine dernière",
  "winningsThisweek": "Gains cette semaine",
  "downlinesChips": "Jetons de la descendance",
  "chipsInPlay": "Chips en jeu"
};